module.exports = __webpack_public_path__ + "static/img/lo_.4966d4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lo_.png
// module id = FrKW
// module chunks = 0